import styled from 'styled-components';

export const BlueButton = styled.button`
    position: static;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    outline:none;
    width: 85%;
    height: 40px;
    margin-top: 16px;
    background: #FFFFFF;
    border: 2px solid #454ADE;
    border-radius: 8px;
    font-family: 'Nunito', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    color: #454ADE;
`;

export const BlueArrow = styled.img`
    margin-left:3px;
`;